import React from 'react';
import MessageForm from './components/MessageForm';
import PhoneForm from './components/PhoneForm';

const Contact = (props) => {
  if (props.pageData.contact_mode == 'bytel') {
    return <PhoneForm {...props} />;
  }
  if (!props.pageData.message_sent) {
    return <MessageForm {...props} />;
  }
  return false;
};

export default Contact;
